export default __webpack_public_path__ + "static/media/Snd2.37884487.mp3";